/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Object to manage the confirmation dialog for invalid data.
     */
    Alpine.store('invalidConfirmationDialog', {
        /**
         * @var bool true when Dialog popup is showing.
         */
        isDialogOpen: false,

        /**
         * Show the confirmation dialog.
         *
         * @return void
         */
        show() {
            this.isDialogOpen = true;
        },

        /**
         * Hide the confirmation dialog.
         *
         * @return void
         */
        hide() {
            this.isDialogOpen = false;
        },

        /**
         * used buy x-show to determine if the confirmation dialog should be displayed.
         *
         * @returns bool True - Show the dialog, False - Hide the dialog.
         */
        isVisible() {
            return this.isDialogOpen;
        }
    });
});
